<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <DataTable
          :headers="headers"
          :items="documents"
          module="Document"
          model="documents"
          delete-callback="deleteDocumentById"
          @handlePageChanged="getDocuments"
          @handleEditItem="handleEditItem"
          @handleDeleteItem="handleDeleteItem"
        >
          <template #top>
            <CreateDocumentModal />
            <EditDocumentModal />
            <TableTopToolbar
              entity="Dokument"
              title="Dokument Lista"
              model="documents"
              @filter="getDocuments"
            />
          </template>
        </DataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "DocumentsList",
  computed: {
    ...mapGetters("Document", ["documents", "headers"])
  },
  mounted() {
    this.getDocuments();
    this.getAllMetas();
    this.getAllIssuers();
    this.getAllRegulators();
  },
  methods: {
    ...mapActions("Document", [
      "getDocuments",
      "getAllIssuers",
      "getDocumentById",
      "deleteDocumentById"
    ]),
    ...mapActions("Meta", ["getAllMetas"]),
    ...mapActions("Regulator", ["getAllRegulators"]),
    handleEditItem({ id }) {
      this.getDocumentById(id);
    },
    handleDeleteItem({ id }) {
      this.deleteDocumentById(id);
    }
  }
};
</script>

<style></style>
